import ColumnFilter from '../../ColumnFilter';
import { useState } from 'react';
import { useDebouncedOnChange } from '@/hooks';
import { flatInfiniteData } from '@/utils/request/flatInfiniteData';
import { Button } from 'antd';
import { useManufacturers } from '@/core/domain/operational/Manufacturers/Manufacturers.hooks';

interface Props {
  onChange(value: number): void;
  value?: number;
}

const ManufacturerColumnFilter: React.FC<Props> = (props) => {
  const [search, setSearch] = useState('');
  const [value, setValue] = useState();

  const onSearch = useDebouncedOnChange(setSearch);

  const { data, isLoading, isFetching, hasNextPage, fetchNextPage } =
    useManufacturers({
      active: true,
      name: search,
    });

  const dataSource = flatInfiniteData(data);

  return (
    <ColumnFilter
      loading={isLoading}
      onSearch={onSearch}
      onChange={(value) => {
        props.onChange(value);
        setValue(value);
      }}
      value={props.value || value}
      dataSource={dataSource.map((item) => ({
        value: item.id,
        label: item.name,
      }))}
      footer={
        hasNextPage && (
          <Button
            type="primary"
            block
            loading={isFetching}
            onClick={() => fetchNextPage()}
          >
            Carregar mais
          </Button>
        )
      }
    />
  );
};

export default ManufacturerColumnFilter;
